import React from "react";
import useAudioContext from "../hooks/audio-context";
import { classNames } from "~/utils";

interface HighlightWrapperProps {
  index: number;
  duration?: number;
  start?: number;
  Component: any;
  class?: string;
}

export const CurrentChunkClassName = "current-transcript-chunk";
export const IndexChunkClassNamePrefix = "transcript-chunk";

export default function Paragraph({
  Component,
  duration,
  start,
  index,
  children,
  class: clazz,
  ...props
}: React.PropsWithChildren<HighlightWrapperProps>) {
  const videoContext = useAudioContext();
  let karaokeHighlighted = false;
  if (
    start !== undefined &&
    start >= 0 &&
    duration !== undefined &&
    duration >= 0
  ) {
    karaokeHighlighted =
      videoContext.currentTimestamp >= start &&
      videoContext.currentTimestamp < start + duration;
  }
  return (
    <Component
      id=""
      className={classNames(
        `${IndexChunkClassNamePrefix}-${index}`,
        clazz ? clazz : "",
        "w-full",
        videoContext.currentTimestamp >= 0
          ? karaokeHighlighted
            ? `${CurrentChunkClassName}  text-[#312658] dark:text-[#CDA8FF] font-medium`
            : "text-muted-foreground"
          : "",
      )}
      {...props}
    >
      {children}
    </Component>
  );
}
